import React, { useEffect, useState } from "react";
import BoardChat from "@/components/BoardChat";
import FiltersSidebar from "@/components/FiltersSidebar";

// Left column of the board Dashboard. Groups two independently collapsible
// panels — chat on top (per user request) and filters below — inside the
// same sticky aside so the outer geometry stays identical to the previous
// single-panel FiltersSidebar layout.
//
// Collapse state is persisted per-board in localStorage so users don't have
// to re-collapse on every navigation.
const KEY = (boardId) => `immomap:leftPanel:${boardId}`;

const LeftSidebar = ({ boardId, isOwner = false, filters, setFilters, facets, onReset }) => {
  const [chatCollapsed, setChatCollapsed] = useState(false);
  const [filtersCollapsed, setFiltersCollapsed] = useState(false);

  useEffect(() => {
    if (!boardId) return;
    try {
      const raw = localStorage.getItem(KEY(boardId));
      if (raw) {
        const p = JSON.parse(raw);
        // Whitelist + type-check — corrupted or tampered values are
        // silently ignored so the panels open in the default state.
        if (p && typeof p === "object") {
          if (typeof p.chat === "boolean") setChatCollapsed(p.chat);
          if (typeof p.filters === "boolean") setFiltersCollapsed(p.filters);
        }
      }
    } catch (err) {
      console.warn("[LeftSidebar] load prefs failed:", err);
    }
  }, [boardId]);

  useEffect(() => {
    if (!boardId) return;
    try {
      localStorage.setItem(
        KEY(boardId),
        JSON.stringify({ chat: chatCollapsed, filters: filtersCollapsed }),
      );
    } catch (err) {
      console.warn("[LeftSidebar] save prefs failed:", err);
    }
  }, [boardId, chatCollapsed, filtersCollapsed]);

  return (
    <aside
      className="w-72 shrink-0 h-[calc(100vh-3.5rem)] sticky top-14 overflow-y-auto p-4 space-y-3"
      data-testid="board-left-sidebar"
    >
      <BoardChat
        boardId={boardId}
        isOwner={isOwner}
        collapsed={chatCollapsed}
        onToggle={() => setChatCollapsed((v) => !v)}
      />
      <FiltersSidebar
        filters={filters}
        setFilters={setFilters}
        facets={facets}
        onReset={onReset}
        boardId={boardId}
        collapsed={filtersCollapsed}
        onToggleCollapsed={() => setFiltersCollapsed((v) => !v)}
      />
    </aside>
  );
};

export default LeftSidebar;
